/* eslint-disable react/jsx-closing-tag-location */
import React from "react";
import PropTypes from "prop-types";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSortDown, faSortUp, faTimesCircle, faTags, faCheckDouble, faExchangeAlt, faTag } from "@fortawesome/free-solid-svg-icons";
import LoadingAnimation from "../loadingAnimation/loadingAnimation";
import Modal from "react-modal";
import MultiSelectDropdown from "../multiSelectDropdown/multiSelectDropdown";

export default class PricingOptionCategory extends React.Component {
  constructor(props) {
    super(props);
    this.handleCheckOption = this.handleCheckOption.bind(this);
    this.data = this.props.data;
    this.name = this.props.name;
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.getTags = this.getTags.bind(this);
    this.handleAfterOpenModal = this.handleAfterOpenModal.bind(this);
    this.state = {
      isLoading: false,
      haveData: false,
      showTags: false,
      checkedOptions: [],
      allOptionsChecked: false,
      modalContent: null,
      modalOpen: false,
      showCategoryModal: false,
      showTagsModal: false,
      selectedCategory: {},
      selectedTags: {},
      tags: {}
    };
  }

  toggleCategory(id, rowId) {
    this.props.getPricingOption(id, rowId);
    this.setState({
      isLoading: true
    });
  }

  UNSAFE_componentWillMount() {
    if (this.props.pricingOptions.id === this.props.row) {
      this.setState({
        haveData: true
      });
    } else {
      this.setState({
        haveData: false
      });
    }
  }

  UNSAFE_componentWillReceiveProps() {
    if (this.props.pricingOptions.id === this.props.row) {
      this.setState({
        haveData: true
      });
    } else {
      this.setState({
        haveData: false
      });
    }
  }

  reassign() {
    this.setState({
      modalOpen: true
    });
  }

  toggleTag(tag, id, cat, active, row) {
    if (active) {
      this.props.updatePricingOption(tag, id, cat, false, row);
    } else {
      this.props.updatePricingOption(tag, id, cat, true, row);
    }
  }

  showTags(tag) {
    const showTag = document.getElementById(tag);
    const tagDown = document.getElementById(`${tag}-down`);
    const tagUp = document.getElementById(`${tag}-up`);
    const style = showTag.getAttribute("style");
    if (style === "display: none;") {
      showTag.setAttribute("style", "display: flex");
      tagDown.setAttribute("style", "display: none");
      tagUp.setAttribute("style", "display: block; margin-top: 9px");
    } else {
      showTag.setAttribute("style", "display: none;");
      tagDown.setAttribute("style", "display: block");
      tagUp.setAttribute("style", "display: none");
    }
  }

  toggleAllTags() {
    if (this.state.showTags) {
      this.setState({
        showTags: false
      });
    } else {
      this.setState({
        showTags: true
      });
    }
  }

  selectAllOptions() {
    const checked = [];
    if (this.state.allOptionsChecked) {
      this.props.pricingOptions.data.pricing_options.map(item => {
        document.getElementById(`checkbox-${item.id}`).checked = false;
      });
      this.setState({
        checkedOptions: checked,
        allOptionsChecked: false
      });
    } else {
      this.props.pricingOptions.data.pricing_options.map(item => {
        document.getElementById(`checkbox-${item.id}`).checked = true;
        checked.push(item.id.toString());
      });
      this.setState({
        checkedOptions: checked,
        allOptionsChecked: true
      });
    }
  }

  handleCheckOption(event) {
    const currentChecked = this.state.checkedOptions;

    const index = currentChecked.indexOf(event.target.value);
    if (index > -1) {
      currentChecked.splice(index, 1);
    }
    if (event.target.checked) {
      currentChecked.push(event.target.value);
      this.setState({
        checkedOptions: currentChecked
      });
    }
  }

  handleCloseModal() {
    this.setState({
      modalOpen: false,
      showCategoryModal: false,
      showTagsModal: false
    });
    // this.props.setContactsUpdatedSuccess()
    // console.log('modal close')
  }

  removeCategory() {
    const allCategories = this.props.allCategories;

    const index = allCategories.indexOf(this.props.data);
    if (index > -1) {
      allCategories.splice(index, 1);
    }

    return allCategories;
  }

  getTags() {
    const tags = [];
    this.props.pricingOptions.data.tag_names.map((item, index) => {
      tags.push({ id: index, name: item });
    });
    this.props.pricingOptions.data.tag_changes.map((item, index) => {
      tags[index].value = item;
    });
    this.setState({
      tags: tags
    });
  }

  getNotSelectedTags() {
    const notSelectedTags = this.state.tags.filter(val => !this.state.selectedTags.includes(val));

    // const index = notSelectedTags.indexOf(this.state.selectedTags)
    // if (index > -1) {
    //   notSelectedTags.splice(index, 1)
    // }

    return notSelectedTags;
  }

  getParent() {
    return document.querySelector("body");
  }

  handleAfterOpenModal() {
    this.getTags();
  }

  sendUpdateCategory() {
    //console.log(this.state.selectedCategory.id, this.state.checkedOptions, this.props.row, this.data.id);
    this.props.massUpdateCategory(this.state.selectedCategory.id, this.state.checkedOptions, this.props.row, this.data.id);
  }

  sendUpdateTags() {
    //console.log(this.state.selectedTags, this.getNotSelectedTags(), this.state.checkedOptions, this.props.row, this.data.id);
    this.props.massUpdateTags(this.state.selectedTags, this.getNotSelectedTags(), this.state.checkedOptions, this.props.row, this.data.id);
  }

  closeSearch() {
    this.props.closeSearch(true);
  }

  render() {
    library.add(faSortDown, faSortUp, faTimesCircle, faTags, faCheckDouble, faExchangeAlt, faTag);

    return (
      <div>
        <Modal
          // closeTimeoutMS={500}
          ariaHideApp={false}
          parentSelector={this.getParent}
          className="addContactLogModal"
          isOpen={this.state.modalOpen}
          onAfterOpen={this.handleAfterOpenModal}
          onRequestClose={this.handleCloseModal}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              zIndex: 10000
            },
            content: {
              position: "absolute",
              top: "50%",
              left: "50%",
              width: 800,
              height: 550,
              bottom: 40,
              backgroundColor: "white",
              borderRadius: "10px",
              border: "solid 1px #444",
              padding: "25px",
              outline: "none",
              zIndex: 100000,
              overflow: "scroll",
              margin: "-275px 0 0 -400px"
            }
          }}
          contentLabel="Contact Log Modal"
        >
          {!this.state.showCategoryModal & !this.state.showTagsModal ? (
            <div>
              <h1>Mass Update</h1>
              <p>
                What do you want to update for the <b style={{ fontSize: "24px" }}>{this.state.checkedOptions.length}</b> selected pricing options?
              </p>
              <div className="select-type" style={{ paddingTop: "25px" }}>
                <button style={styles.submit} onClick={() => this.setState({ showCategoryModal: true })}>
                  Category
                </button>
                <button style={styles.submit} onClick={() => this.setState({ showTagsModal: true })}>
                  Tags
                </button>
              </div>
            </div>
          ) : null}
          {this.state.showCategoryModal ? (
            <div>
              <h1>Update Revenue Category</h1>
              <p>
                Select new revenue category for the <b style={{ fontSize: "24px" }}>{this.state.checkedOptions.length}</b> selected pricing options.
              </p>
              <div style={{ width: "300px", marginTop: "20px", float: "left" }}>
                <MultiSelectDropdown
                  options={this.removeCategory()}
                  height={350}
                  singlePicker
                  placeholder="Select Category"
                  selectAll={false}
                  enableOnly={false}
                  numberDisplayed={1}
                  includeSelectAll={false}
                  defaultSelected={false}
                  haveOnSelectChange
                  onSelectChange={value => {
                    this.setState({ selectedCategory: value.length !== 2 ? value[0] : value[1] });
                  }}
                  enableMax
                  maxSelect={1}
                  maxSelected={data => console.log(data)}
                />
              </div>
              <button
                onClick={() => this.sendUpdateCategory()}
                style={{
                  ...styles.submit,
                  margin: "22px 0 0 17px",
                  float: "left",
                  display: Object.entries(this.state.selectedCategory).length === 0 && this.state.selectedCategory.constructor === Object ? "none" : "block"
                }}
              >
                Submit
              </button>
            </div>
          ) : null}
          {this.state.showTagsModal ? (
            <div>
              <h1>Update Tags</h1>
              <p>
                Select tags for the <b style={{ fontSize: "24px" }}>{this.state.checkedOptions.length}</b> selected pricing options.
              </p>
              <div style={{ width: "300px", marginTop: "20px", float: "left" }}>
                <MultiSelectDropdown
                  options={this.state.tags}
                  height={350}
                  placeholder="Select Tags"
                  selectAll={false}
                  enableOnly
                  numberDisplayed={3}
                  includeSelectAll
                  defaultSelected={false}
                  haveOnSelectChange
                  onSelectChange={value => {
                    this.setState({ selectedTags: value });
                  }}
                />
              </div>
              <button
                onClick={() => this.sendUpdateTags()}
                style={{
                  ...styles.submit,
                  margin: "22px 0 0 17px",
                  float: "left",
                  display: Object.entries(this.state.selectedTags).length === 0 && this.state.selectedTags.constructor === Object ? "none" : "block"
                }}
              >
                Submit
              </button>
            </div>
          ) : null}
        </Modal>
        <div className="primary-categories" id={this.props.row} style={styles.primary_category}>
          <p onClick={() => this.toggleCategory(this.data.id, this.props.row)}>
            <b>{this.name}</b> | {this.props.searchActive ? this.props.searchQuery : this.data.name} (
            {this.props.searchActive ? this.props.pricingOptions.data.pricing_options.length : this.data.pricing_options_count}){" "}
            {this.props.searchActive && (
              <button style={{ ...styles.options, position: "absolute", right: "22px", background: "rgb(26, 28, 34)" }} onClick={() => this.closeSearch()}>
                <FontAwesomeIcon icon="times-circle" /> Close
              </button>
            )}
          </p>
          {this.props.optionLoading.loading & (this.props.optionLoading.id === this.props.row) ? <LoadingAnimation customStyle="dark" /> : null}
          {this.state.haveData && (
            <div>
              <button style={styles.options} onClick={() => this.toggleAllTags()}>
                <FontAwesomeIcon icon="tags" /> {this.state.showTags ? "Hide" : "Show"} all Tags
              </button>
              <button style={styles.options} onClick={() => this.selectAllOptions()}>
                <FontAwesomeIcon icon="check-double" /> {this.state.allOptionsChecked ? "De-select" : "Select"} all Options
              </button>
              {this.state.checkedOptions.length > 0 && (
                <button style={styles.options} onClick={() => this.reassign()}>
                  <FontAwesomeIcon icon="exchange-alt" /> Reassign Option
                </button>
              )}
              <div className="fields" style={styles.fields}>
                {this.props.pricingOptions.data.field_names.map(item => {
                  return (
                    <div key={`field-${item}`} className="field" style={styles.field}>
                      {item}
                    </div>
                  );
                })}
              </div>
              {this.props.pricingOptions.data.pricing_options.map((item, index) => {
                const id = item.id;
                const name = item.fields[0];
                const revenue_category_id = item.revenue_category_id;
                return (
                  <div
                    key={`item-${item.fields[0]}-${index}`}
                    style={{ backgroundColor: index % 2 === 0 ? "rgb(245, 245, 245)" : "white", padding: "5px 5px 5px 0" }}
                  >
                    <div style={{ display: "flex" }}>
                      <div onClick={() => this.showTags(`tag-${name}`)} style={{ paddingRight: "5px", marginTop: "-3px", paddingLeft: "5px" }}>
                        <FontAwesomeIcon id={`tag-${name}-down`} icon="sort-down" style={{ display: this.state.showTags ? "none" : "block" }} />
                        <FontAwesomeIcon id={`tag-${name}-up`} style={{ display: this.state.showTags ? "block" : "none", marginTop: "9px" }} icon="sort-up" />
                      </div>
                      <input type="checkbox" id={`checkbox-${id}`} value={id} onChange={this.handleCheckOption} style={{ margin: "5px" }} />
                      {item.fields.map((item, index) => {
                        return (
                          <div onClick={() => this.showTags(`tag-${name}`)} key={`${item}-${index}`} style={styles.field}>
                            {item.toString()}
                          </div>
                        );
                      })}
                    </div>
                    <div id={`tag-${name}`} key={`tag-${item.tags[0]}`} style={{ display: this.state.showTags ? "flex" : "none" }}>
                      {item.tags.map((item, index) => {
                        return (
                          <button
                            onClick={() => this.toggleTag(this.props.pricingOptions.data.tag_changes[index], id, revenue_category_id, item, this.props.row)}
                            key={`${item}-${index}`}
                            style={{ ...styles.button, backgroundColor: item && "rgb(74, 155, 255)", color: item && "rgb(255, 255, 255)" }}
                          >
                            {item && <FontAwesomeIcon icon="tag" />} {this.props.pricingOptions.data.tag_names[index]}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}

PricingOptionCategory.propTypes = {
  getPricingOption: PropTypes.func,
  data: PropTypes.object,
  name: PropTypes.string,
  pricingOptions: PropTypes.object,
  row: PropTypes.string,
  optionLoading: PropTypes.object,
  updatePricingOption: PropTypes.func,
  allCategories: PropTypes.array,
  massUpdateCategory: PropTypes.func,
  massUpdateTags: PropTypes.func,
  searchActive: PropTypes.bool,
  searchQuery: PropTypes.string,
  closeSearch: PropTypes.func
};
const styles = {
  fields: {
    width: "100%",
    display: "flex",
    paddingTop: "25px",
    borderBottom: "solid 1px #ccc",
    fontWeight: "700"
  },
  submit: {
    padding: "7px 25px",
    background: "#7ec02b",
    border: "none",
    borderRadius: "25px",
    color: "white",
    fontWeight: "bold",
    textTransform: "uppercase",
    fontSize: "14px",
    marginRight: "15px",
    cursor: "pointer"
  },
  options: {
    borderRadius: "5px",
    background: "#8bc34a",
    fontWeight: 800,
    padding: "5px 10px 5px 10px",
    marginRight: "10px",
    color: "white"
  },
  field: {
    width: "100%"
  },
  showTags: {
    float: "left",
    paddingRight: "5px"
  },
  button: {
    padding: "0px 15px",
    height: "25px",
    marginBottom: "10px",
    marginTop: "5px",
    marginLeft: "12px",
    fontsize: "14px",
    fontWeight: 700,
    fontSize: "13px",
    color: "#0000008a",
    cursor: "pointer",
    borderRadius: "5px",
    border: "solid 1px #a0a0a0"
  },
  primary_category: {
    width: "100%",
    backgroundColor: "white",
    borderRadius: "5px",
    margin: "15px 0 15px 0",
    padding: "10px",
    cursor: "pointer",
    border: "solid 1px #c4c4c4"
  }
};
